import { DepartmentApiModel } from 'app/models/department-api.model';
import * as actions from '../actions/departments.actions';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { Action, createReducer, on } from '@ngrx/store';

export interface State {
  departments: DepartmentApiModel[];
  isLoading: boolean;
  isReady: boolean;
}

export const initialState: State = {
  departments: [],
  isLoading: false,
  isReady: false,
};

export const featureReducer = createReducer(
  initialState,
  on(actions.loadDepartmentsSuccess, (state: State, { items }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    departments: items,
  })),
  on(actions.loadDepartments, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(setActiveCompany, actions.resetDepartments, () => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
